import React from 'react'
import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { ImportListMemberAnnounce4Component } from '../../components/SupportSystem/ImportListMemberAnnounce4Component';
import { Footer } from "../../components/share/Footer";
export const ImportListMemberAnnounce4Container = () => {
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={"นำเข้ารายชื่อผู้ผ่านทดสอบ (ประกาศ 4)"}></HeadTitle>
            <ImportListMemberAnnounce4Component />
            <Footer />
        </div>
    )
}
